import React from 'react';
import styled from 'styled-components';
import {
  svgIconInternalStyling,
} from '../sectionNav/Circle';
import { primaryColor1 } from '../Utils';

//#region Styling
const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  --icon-color-2: ${primaryColor1};
  --icon-color-1: ${primaryColor1};
  --icon-background-color: transparent;

  &:hover {
    --icon-color-2: white;
    --icon-color-1: white;
    --icon-background-color: ${primaryColor1};

    cursor: pointer;
    position: relative;
  }

  & + div {
    margin-left: 0.8rem;
  }
`;
const iconOuterSize = 2.8; // in rem
const iconInnerSize = 1.7; // in rem
const SVGIconOuterContainer = styled.div`
  border-radius: 50%;
  border: 1px solid ${primaryColor1};
  width: ${iconOuterSize}rem;
  height: ${iconOuterSize}rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--icon-background-color);
  margin-bottom: 0.5rem;
`;
const SVGIconInnerContainer = styled.div`
  width: ${iconInnerSize}rem;
  height: ${iconInnerSize}rem;
  position: relative;
  ${svgIconInternalStyling}
`;
const Label = styled.div`
  text-transform: uppercase;
  color: ${primaryColor1};
  font-size: 0.625rem;
  text-align: center;
  letter-spacing: 0.01rem;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
`;

//#endregion

interface Props {
  onClick: () => void;
  label: string;
  svgFileName: string;
}

const Icon = (props: Props) => {
  const {onClick, label, svgFileName} = props;
  return (
    <Root onClick={onClick}>
      <SVGIconOuterContainer>
        <SVGIconInnerContainer dangerouslySetInnerHTML={{__html: require('../sectionNav/icons/' + svgFileName)}} />
      </SVGIconOuterContainer>
      <Label>{label}</Label>
    </Root>
  );
};

export default Icon;
